import { render, staticRenderFns } from "./CentralBillingComparison.vue?vue&type=template&id=71a0991b&scoped=true&"
import script from "./CentralBillingComparison.vue?vue&type=script&lang=ts&"
export * from "./CentralBillingComparison.vue?vue&type=script&lang=ts&"
import style0 from "./CentralBillingComparison.vue?vue&type=style&index=0&id=71a0991b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a0991b",
  null
  
)

export default component.exports